import { render, staticRenderFns } from "./VideoThumb.vue?vue&type=template&id=c24112d4&"
import script from "./VideoThumb.vue?vue&type=script&lang=js&"
export * from "./VideoThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports